export default () => ({
	path: '*',
	onEnter: (_, replace) => {
		replace({ pathname: '/' });
	},
});



// WEBPACK FOOTER //
// ./src/routes/Hotel/NotFound/index.js